// extracted by mini-css-extract-plugin
module.exports = {"radioButton":"Belief--radioButton","agree":"Belief--agree","disagree":"Belief--disagree"};